import { type LOAN_REQUEST_COMMAND, LOAN_REQUEST_COMMANDS } from 'cpool-constants';

import type { SchemaIncomeForm } from '~/features/leadDetails/schemas/income.schema.ts';

export type IncomeType = keyof SchemaIncomeForm;

type IncomeTypeConfig = {
    addCommand: LOAN_REQUEST_COMMAND;
    changeCommand: LOAN_REQUEST_COMMAND;
    label: `LEADS.DETAILS.INCOME.${IncomeType}`;
    removeCommand: LOAN_REQUEST_COMMAND;
};

export const incomeTypeConfig: Record<IncomeType, IncomeTypeConfig> = {
    ehegattenunterhalt: {
        addCommand: LOAN_REQUEST_COMMANDS.addIncomeSpouse,
        changeCommand: LOAN_REQUEST_COMMANDS.changeIncomeSpouse,
        label: 'LEADS.DETAILS.INCOME.ehegattenunterhalt',
        removeCommand: LOAN_REQUEST_COMMANDS.removeIncomeSpouse,
    },
    einkuenfteAusKapitalvermoegen: {
        addCommand: LOAN_REQUEST_COMMANDS.addIncomeCapital,
        changeCommand: LOAN_REQUEST_COMMANDS.changeIncomeCapital,
        label: 'LEADS.DETAILS.INCOME.einkuenfteAusKapitalvermoegen',
        removeCommand: LOAN_REQUEST_COMMANDS.removeIncomeCapital,
    },
    einkuenfteAusNebentaetigkeit: {
        addCommand: LOAN_REQUEST_COMMANDS.addIncomeSecondaryEmployment,
        changeCommand: LOAN_REQUEST_COMMANDS.changeIncomeSecondaryEmployment,
        label: 'LEADS.DETAILS.INCOME.einkuenfteAusNebentaetigkeit',
        removeCommand: LOAN_REQUEST_COMMANDS.removeIncomeSecondaryEmployment,
    },
    sonstigeEinnahmen: {
        addCommand: LOAN_REQUEST_COMMANDS.addIncomeOther,
        changeCommand: LOAN_REQUEST_COMMANDS.changeIncomeOther,
        label: 'LEADS.DETAILS.INCOME.sonstigeEinnahmen',
        removeCommand: LOAN_REQUEST_COMMANDS.removeIncomeOther,
    },
    unbefristeteZusatzrenten: {
        addCommand: LOAN_REQUEST_COMMANDS.addIncomePension,
        changeCommand: LOAN_REQUEST_COMMANDS.changeIncomePension,
        label: 'LEADS.DETAILS.INCOME.unbefristeteZusatzrenten',
        removeCommand: LOAN_REQUEST_COMMANDS.removeIncomePension,
    },
};

export const incomeListOrder: IncomeType[] = [
    'unbefristeteZusatzrenten',
    'sonstigeEinnahmen',
    'ehegattenunterhalt',
    'einkuenfteAusKapitalvermoegen',
    'einkuenfteAusNebentaetigkeit',
];

export const incomeAddButtonOrder: IncomeType[] = [
    'einkuenfteAusNebentaetigkeit',
    'unbefristeteZusatzrenten',
    'ehegattenunterhalt',
    'einkuenfteAusKapitalvermoegen',
    'sonstigeEinnahmen',
];
